export const updateProfileValues = (data) => {
  const initialValues = {
    fName: data.fName,
    lName: data.lName,
    gender: data.gender,
    dob: data.dob,
    maritalStatus: data.maritalStatus,
    phone: data.phone,
    address: data.address,
    city: data.city,
    occupation: data.occupation,
    currentEmployer: data.currentEmployer,
    employerAddress: data.employerAddress,
    nextOfKin: data.nextOfKin,
    nextofKinAddress: data.nextofKinAddress,
  };
  return initialValues;
};

export const addBankValues = () => {
  const initialValues = {
    bankName: '',
    accountName: '',
    accountNumber: '',
    accountType: '',
  };
  return initialValues;
};

export const withdrawValues = (balance) => {
  const initialValues = {
    balance: balance,
    amount: '',
    bank: '',
  };
  return initialValues;
};
